import { createActionName } from "../../utility"

export const reducerName = "invitation"

export const CHECK_INVITATION = createActionName(reducerName, "CHECK_INVITATION")
export const VALIDATE_ACCOUNT = createActionName(reducerName, "VALIDATE_ACCOUNT")
export const CREATE_ACCOUNT = createActionName(reducerName, "CREATE_ACCOUNT")
export const SET_STEP = createActionName(reducerName, "SET_STEP")
export const RESET = createActionName(reducerName, "RESET")
